interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
}

export default function SEOMeta({ title, description, keywords, canonicalUrl, ogImage, ogType = 'website' }: SEOMetaProps) {
  useEffect(() => {
    const siteName = '校花文化网';
    const fullTitle = `${title} - ${siteName}`;

    document.title = fullTitle;

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setProp = (prop: string, content: string) => {
      let el = document.querySelector(`meta[property="${prop}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', prop);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    setProp('og:title', fullTitle);
    setProp('og:description', description);
    setProp('og:type', ogType);
    if (canonicalUrl) {
      setProp('og:url', canonicalUrl);
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }
    if (ogImage) setProp('og:image', ogImage);

    setProp('twitter:card', 'summary_large_image');
    setProp('twitter:title', fullTitle);
    setProp('twitter:description', description);
    if (ogImage) setProp('twitter:image', ogImage);
  }, [title, description, keywords, canonicalUrl, ogImage, ogType]);

  return null;
}